import React from 'react'
import Header from '../Header'
import Footer from '../Footer'
import ManageAddress from '../Profile/ManageAddress'

const ManageAddressPage = () => {
  return (
    <>
        <Header/>
        <ManageAddress/>
        <Footer/>
    </>
  )
}

export default ManageAddressPage